import { Inject, Injectable } from '@rxdi/core';
import { css, html } from '@rxdi/lit-html';
import { Nav } from '@rxdi/ui-kit/nav';

@Injectable()
export class NavMenuProvider {
  @Inject(Nav) private nav: Nav;
  getSubject() {
    return this.nav.getOpenSubject();
  }
  openNavigation() {
    this.nav.open({
      navOptions: {
        left: 0,
        delay: 0,
      },
      template: html`
        <div>
          <p>daadad</p>
        </div>
      `,
      styles: css`
        p {
          color: black;
        }
        :host {
          position: fixed;
          top: 0;
          transition: left 0.3s ease-out;
          bottom: 0;
          left: -250px;
          box-sizing: border-box;
          min-width: 250px;
          background: #fff;
          overflow-y: auto;
        }
      `,
    });
  }
  closeNavigation() {
    this.nav.close({ delay: 300, left: -250 });
  }
}
